module.exports = __webpack_public_path__ + "static/media/funchal-15.1b006bb5.jpg";